import React, { useEffect } from 'react';
import { useSEOContent, getContentByKey } from '../../hooks/useDynamicContent';

function DynamicSEO({ 
    title, 
    description, 
    keywords, 
    image, 
    url,
    type = 'website' 
}) {
    const { content: seoContent, loading } = useSEOContent();

    useEffect(() => {
        if (loading) return;

        // Get dynamic SEO content
        const dynamicTitle = getContentByKey(seoContent, 'seo_homepage_title', 'Spoon & Spice - India\'s No.1 Home Catering Platform');
        const dynamicDescription = getContentByKey(seoContent, 'seo_homepage_description', 'Discover delicious food, professional service, and unforgettable experiences for your special occasions.');
        const dynamicKeywords = getContentByKey(seoContent, 'seo_keywords', 'catering, food delivery, wedding catering, birthday catering, corporate events');

        // Use provided props or fallback to dynamic content
        const finalTitle = title || dynamicTitle;
        const finalDescription = description || dynamicDescription;
        const finalKeywords = keywords || dynamicKeywords;
        const finalImage = image || '/images/hero-catering.jpg';
        const finalUrl = url || window.location.href;

        // Update document title
        document.title = finalTitle;

        // Update meta tags
        updateMetaTag('description', finalDescription);
        updateMetaTag('keywords', finalKeywords);
        updateMetaTag('author', 'Spoon & Spice');

        // Open Graph tags
        updateMetaTag('og:title', finalTitle, 'property');
        updateMetaTag('og:description', finalDescription, 'property');
        updateMetaTag('og:image', finalImage, 'property');
        updateMetaTag('og:url', finalUrl, 'property');
        updateMetaTag('og:type', type, 'property');
        updateMetaTag('og:site_name', 'Spoon & Spice', 'property');

        // Twitter Card tags
        updateMetaTag('twitter:card', 'summary_large_image', 'name');
        updateMetaTag('twitter:title', finalTitle, 'name');
        updateMetaTag('twitter:description', finalDescription, 'name');
        updateMetaTag('twitter:image', finalImage, 'name');

        // Additional SEO tags
        updateMetaTag('robots', 'index, follow');
        updateMetaTag('viewport', 'width=device-width, initial-scale=1.0');
        updateMetaTag('theme-color', '#6366F1');

        // Canonical URL
        updateLinkTag('canonical', finalUrl);

    }, [loading, title, description, keywords, image, url, type, seoContent]);

    const updateMetaTag = (name, content, attribute = 'name') => {
        let meta = document.querySelector(`meta[${attribute}="${name}"]`);
        if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute(attribute, name);
            document.head.appendChild(meta);
        }
        meta.setAttribute('content', content);
    };

    const updateLinkTag = (rel, href) => {
        let link = document.querySelector(`link[rel="${rel}"]`);
        if (!link) {
            link = document.createElement('link');
            link.setAttribute('rel', rel);
            document.head.appendChild(link);
        }
        link.setAttribute('href', href);
    };

    return null; // This component doesn't render anything
}

export default DynamicSEO;
